import React, { useEffect, useState } from 'react';
import './Context.css';
import {  FaLinkedin, FaEnvelope, FaWhatsapp, FaInstagram } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaRegHandshake } from 'react-icons/fa';

export const Context = () => {
  const [status, setStatus] = useState('');

  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);



  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
     setIsLoading(true);

    const response = await fetch("https://formspree.io/f/mjkobgjo", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: data,
    });

    setIsLoading(false);

    if (response.ok) {
      setStatus("SUCCESS");
      form.reset();
       setShowPopup(true);

  setTimeout(() => {
    setShowPopup(false); // Hide after 3 seconds
  }, 3000);
      

    } else {
      setStatus("ERROR");
    }
  };

  return (
    <div className="context-container" id="contact">

    {showPopup && ( <div className="popup-message enhanced-popup" data-aos="zoom-in">
  <img src="https://cdn-icons-png.flaticon.com/512/190/190411.png" alt="Success" className="popup-icon" />
  <span>Message Sent Successfully!</span>
</div>
)}

      
      {/* Intro & Icons */}
      <div className="context-text" data-aos="fade-down">
        <div class="heading-wrapper">
        <span class="emoji bounce handshake">🤝</span><h1 class="glow-text">Get in Touch</h1><span class="emoji wave">👋</span>
      </div>
  
        <p>Let's collaborate or just connect! Drop a message below or reach out via social media.</p>
        <div className="context-icons">
          <a href="https://instagram.com/ragul_m__" target="_blank" rel="noopener noreferrer"><FaInstagram className="icon" /></a>
          <a href="https://www.linkedin.com/in/ragul-m-51b672331" target="_blank" rel="noopener noreferrer"><FaLinkedin className="icon" /></a>
          <a href="mailto:ragulm550@gmail.com?subject=Let's%20Connect&body=Hi%20Ragul,%0AI%20saw%20your%20portfolio%20and%20wanted%20to%20reach%20out."><FaEnvelope className="icon" /></a>
          <a href="https://wa.me/918248486606?text=Hi%20Ragul%2C%20I%27m%20interested%20in%20connecting%20with%20you." target="_blank" rel="noopener noreferrer"><FaWhatsapp className="icon" /></a>
        </div>
      </div>

      {/* Contact Form */}
      <form className="contact-form" data-aos="fade-up" onSubmit={handleSubmit}>
        {/* Name */}
        <div className="input-group" data-aos="fade-up" data-aos-delay="100">
          <input type="text" name="name" required placeholder=" " />
          <label>
            {"Name".split("").map((char, i) => (
              <span key={i} style={{ transitionDelay: `${i * 50}ms` }}>{char}</span>
            ))}
          </label>
        </div>

        {/* Email */}
        <div className="input-group" data-aos="fade-up" data-aos-delay="200">
          <input type="email" name="email" required placeholder=" " />
          <label>
            {"Email".split("").map((char, i) => (
              <span key={i} style={{ transitionDelay: `${i * 50}ms` }}>{char}</span>
            ))}
          </label>
        </div>

        {/* Phone */}
        <div className="input-group" data-aos="fade-up" data-aos-delay="300">
          <input type="tel" name="phone"  required placeholder=" " />
          <label>
            {"Mobile Number".split("").map((char, i) => (
              <span key={i} style={{ transitionDelay: `${i * 50}ms` }}>{char}</span>
            ))}
          </label>
        </div>

        {/* Message */}
        <div className="input-group" data-aos="fade-up" data-aos-delay="400">
          <textarea rows="5" name="message" required placeholder=" "></textarea>
          <label>
            {"Message".split("").map((char, i) => (
              <span key={i} style={{ transitionDelay: `${i * 50}ms` }}>{char}</span>
            ))}
          </label>
        </div>

        {/* Submit Button */}
        <button type="submit"  disabled={isLoading}>
                    {isLoading ? (
              <div className="loading-content">
                <span className="spinner"></span>
                <span className="loading-text">Sending...</span>
              </div>
            ) : (
              "Send Message"
            )}
         </button>
      </form>
    </div>
  );
};
